import { useState, useEffect } from 'react';

/**
 * Fetches a form protection token when the component mounts.
 * The token must be included in form submissions for anti-spam validation.
 */
export function useFormToken(): { token: string | null; tokenError: string | null } {
  const [token, setToken] = useState<string | null>(null);
  const [tokenError, setTokenError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchToken() {
      try {
        const res = await fetch('/api/form-token');
        if (!res.ok) {
          throw new Error('Failed to initialize form. Please refresh the page.');
        }
        const data = await res.json();
        if (!cancelled) {
          setToken(data.token);
        }
      } catch (err: unknown) {
        if (!cancelled) {
          const message = err instanceof Error ? err.message : 'Failed to initialize form.';
          setTokenError(message);
        }
      }
    }

    fetchToken();

    return () => {
      cancelled = true;
    };
  }, []);

  return { token, tokenError };
}
